import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SvgAttribute } from "@/shared/constants/constants";
import { WalletListResponse } from "@/shared/repository/modules/wallet/repo";
import { WalletModalFactory } from "@/shared/repository/modules/wallet/factory";
import { AdminApplicationType } from "@/shared/repository/modules/admin/application/enums";
import { AdminCurrencyType } from "@/shared/repository/modules/admin/currency/enums";
import {
  formatFiatCurrency,
  formatCryptoCurrency,
} from "@/shared/utils/amount-helpers";
import { ApplicationStoreRequestFactory } from "@/shared/repository/modules/application/factory";
import {
  HistoryTab,
  RoutesName,
  HistoryFiatCryptoTab,
} from "@/shared/constants/enums";
import { HistoryFilterRequestFactory } from "@/shared/factory/history";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    row: {
      type: <PropType<WalletListResponse>>Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
      walletRepo: this.$projectServices.walletRepo,
      applicationRepo: this.$projectServices.applicationRepo,
      historyRepo: this.$projectServices.historyRepo,
      userRepo: this.$projectServices.userRepo,
    };
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedAmount(): string {
      const { type, amount } = this.row;
      const result =
        type == AdminCurrencyType.fiat
          ? formatFiatCurrency(amount)
          : formatCryptoCurrency(amount);
      return result != "0" ? result : "";
    },
    notVerified(): boolean {
      return !this.userRepo.isVerified;
    },
  },
  methods: {
    handleDeposit(): void {
      if (this.row.type == AdminCurrencyType.fiat) {
        this.walletRepo.UPDATE_MODAL(
          WalletModalFactory({
            type: AdminApplicationType.deposit,
            currencyId: this.row.currency_id,
            amount: this.row.amount,
            isDisabled: true,
          })
        );
      } else {
        this.walletRepo.UPDATE_MODAL(
          WalletModalFactory({
            type: AdminApplicationType.criptoDepositAddress,
            currencyId: this.row.currency_id,
          })
        );
      }
    },

    handleWithdrawal(): void {
      if (this.row.type == AdminCurrencyType.fiat) {
        this.walletRepo.UPDATE_MODAL(
          WalletModalFactory({
            type: AdminApplicationType.withdrawal,
            currencyId: this.row.currency_id,
            amount: this.row.amount,
            isDisabled: true,
          })
        );
      } else {
        this.walletRepo.UPDATE_MODAL(
          WalletModalFactory({
            type: AdminApplicationType.walletWithdrawal,
            currencyId: this.row.currency_id,
          })
        );
      }
    },

    handleApplication(): void {
      const { type, currency_id, amount } = this.row;

      if (amount) {
        this.applicationRepo.UPDATE_APPLICATION(
          ApplicationStoreRequestFactory({
            currency_id_from: currency_id,
            currency_type_from: type,
          })
        );
      } else {
        this.applicationRepo.UPDATE_APPLICATION(
          ApplicationStoreRequestFactory({
            currency_id_to: currency_id,
            currency_type_to: type,
          })
        );
      }

      this.$router.push(RoutesName.application);
    },

    handleHistory(): void {
      if (this.row.type == AdminCurrencyType.fiat) {
        this.historyRepo.UPDATE_TAB(HistoryTab.depositWithdrawal);

        this.historyRepo.UPDATE_FILTER(
          HistoryFilterRequestFactory({
            currency_id: `[${this.row.currency_id}]`,
          })
        );

        this.$router.push(RoutesName.history);
      } else {
        this.historyRepo.UPDATE_FIAT_CRYPTO_TAB(HistoryFiatCryptoTab.crypto);
        this.historyRepo.UPDATE_FILTER(
          HistoryFilterRequestFactory({
            coin: this.row.name,
          })
        );
        this.$router.push(RoutesName.history);
      }
    },
  },
});
